import { device } from "@src/theme";
import { SPINNER_SLOT_HEIGHT } from "@src/components/Spinner";
import styled from "styled-components";

export const ScheduleOverviewHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: ${({ theme }): string => theme.margins.medium};
  height: 100%;
  min-height: 0;

  @media ${device.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }): string => theme.margins.xsmall};
    height: auto;
  }
  @media ${device.tablet} {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }): string => theme.margins.xsmall};
    height: auto;
  }
`;
export const ScheduleOverviewHeaderLeft = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  min-width: 0;
  gap: ${({ theme }): string => theme.margins.small};
  height: 100%;

  @media ${device.mobile} {
    height: auto;
    gap: ${({ theme }): string => theme.margins.xsmall};
  }
  @media ${device.tablet} {
    height: auto;
    gap: ${({ theme }): string => theme.margins.xsmall};
  }
`;
export const ScheduleOverviewHeaderCenter = styled.div<{ $active?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: ${SPINNER_SLOT_HEIGHT.small}px;
  height: ${SPINNER_SLOT_HEIGHT.small}px;
  opacity: ${({ $active }): number => ($active ? 1 : 0)};
  visibility: ${({ $active }): string => ($active ? "visible" : "hidden")};
`;

export const ScheduleTitleRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: ${({ theme }): string => theme.margins.small};
  min-height: 40px;
`;

export const SchedulePageTitle = styled.h1`
  margin: 0;
  font-weight: 400;
  white-space: nowrap;
  color: ${({ theme }): string => theme.colors.yellow};
  font-size: clamp(22px, 2.5vw, 36px);
  line-height: 1.1;
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${({ theme }): string => theme.margins.medium};
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-width: 0;

  @media ${device.mobile} {
    gap: ${({ theme }): string => theme.margins.small};
  }
`;

export const ScheduleNewButton = styled.button<{ $active?: boolean }>`
  background-color: ${({ $active, theme }): string =>
    $active ? theme.colors.yellow : theme.colors.darkGray};
  border: 1px solid
    ${({ $active, theme }): string =>
      $active ? theme.colors.darkGray : theme.colors.yellow};
  color: ${({ $active, theme }): string =>
    $active ? theme.colors.darkGray : theme.colors.yellow};
  font-size: 1rem;
  font-weight: bold;
  width: 100px;
  height: 40px;
  border-radius: 25px;
  cursor: pointer;
  flex-shrink: 0;

  @media ${device.mobile} {
    width: 72px;
    height: 34px;
    font-size: 0.85rem;
    border-radius: 17px;
  }
`;

export const WeeksContainer = styled.div`
  display: flex;
  gap: ${({ theme }): string => theme.margins.medium};
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  flex: 1;
  min-width: 0;
  height: 40px;
  flex-shrink: 0;
  scrollbar-gutter: stable;
  -webkit-overflow-scrolling: touch;

  /* Custom scrollbar styling for a premium feel */
  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 2px;
    transition: background 0.3s ease;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 2px;
    transition: background 0.3s ease;
  }

  /* Support for Firefox custom scrollbars */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  /* Make scrollbar visible on hover */
  &:hover {
    scrollbar-color: rgba(255, 255, 255, 0.25) rgba(255, 255, 255, 0.03);

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.03);
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.25);
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }): string => theme.colors.yellow};
    }
  }

  @media ${device.mobile} {
    gap: ${({ theme }): string => theme.margins.small};
  }
`;

export const WeekButton = styled.button<{ active?: boolean }>`
  background-color: ${({ theme, active }): string =>
    active ? theme.colors.yellow : "#00000033"};
  border: 1px solid
    ${({ theme, active }): string =>
      active ? theme.colors.yellow : theme.colors.gray};
  color: ${({ theme, active }): string =>
    active ? theme.colors.black : theme.colors.gray};
  font-size: 1rem;
  font-weight: bold;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  &:hover {
    background-color: ${({ theme, active }): string =>
      active ? theme.colors.yellow : theme.colors.yellow};
    color: ${({ theme, active }): string =>
      active ? theme.colors.black : theme.colors.black};
    border: 1px solid
      ${({ theme, active }): string =>
        active ? theme.colors.yellow : theme.colors.yellow};
  }

  @media ${device.mobile} {
    width: 72px;
    height: 34px;
    font-size: 0.85rem;
  }
`;

export const DownloadButton = styled.button`
  background-color: ${({ theme }): string => theme.colors.yellow};
  border: 1px solid ${({ theme }): string => theme.colors.darkGray};
  color: ${({ theme }): string => theme.colors.black};
  font-size: 1rem;
  font-weight: bold;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
`;

// ContainerPageTopSection removed (redundant with component)

export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  margin-left: ${(props): string => props.theme.margins.xl};
  margin-right: ${(props): string => props.theme.margins.xl};
  padding-bottom: ${(props): string => props.theme.margins.xl};

  @media ${device.mobile} {
    margin-left: ${(props): string => props.theme.margins.medium};
    margin-right: ${(props): string => props.theme.margins.medium};
    padding-bottom: ${(props): string => props.theme.margins.medium};
  }
  @media ${device.tablet} {
    margin-left: ${(props): string => props.theme.margins.medium};
    margin-right: ${(props): string => props.theme.margins.medium};
    padding-bottom: ${(props): string => props.theme.margins.medium};
  }
`;

export const CalendarContainer = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media ${device.mobile} {
    min-width: 800px;
  }

  .rbc-calendar {
    flex: 1;
    min-height: 0;
    height: 100%;
  }

  .rbc-toolbar {
    margin-top: 0;
    margin-bottom: ${({ theme }): string => theme.margins.small};
    min-height: 28px;
    flex-shrink: 0;
  }
`;

export const ToggleViewButton = styled.button<{ $matchPillSize?: boolean }>`
  background-color: transparent;
  border: 1px solid ${({ theme }): string => theme.colors.yellow};
  color: ${({ theme }): string => theme.colors.yellow};
  font-size: ${({ $matchPillSize }) => ($matchPillSize ? "1rem" : "0.85rem")};
  font-weight: ${({ $matchPillSize }) => ($matchPillSize ? "bold" : "600")};
  width: ${({ $matchPillSize }) => ($matchPillSize ? "100px" : "auto")};
  height: ${({ $matchPillSize }) => ($matchPillSize ? "40px" : "34px")};
  padding: ${({ $matchPillSize }) => ($matchPillSize ? "0" : "0 14px")};
  border-radius: ${({ $matchPillSize }) => ($matchPillSize ? "20px" : "17px")};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }): string => theme.colors.yellow};
    color: ${({ theme }): string => theme.colors.black};

    img {
      filter: brightness(0);
    }
  }

  img {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }
`;

// Clickable submitted-playlist id shown on a red schedule slot. Inherits the
// slot's color and only underlines on hover, so it reads as part of the label
// until the user points at it.
export const SubmittedPlaylistLink = styled.a`
  color: inherit;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

// Clickable "N playlists submitted" label shown on a red schedule slot. Opens
// the playlists page pre-filtered by this show in a new tab. Reads as part of
// the label until hovered, when it gains a red underline to signal the action.
export const SubmittedShowSearchLink = styled.a`
  color: inherit;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    text-decoration-color: ${(props): string => props.theme.colors.red};
    text-underline-offset: 2px;
  }
`;
